<!--服务板块 -->
<template>
  <div class="zlr-card-service"
       :class=[kindClass]
       @click="clickHandle">
    <div class="zlr-card-service-content">
      <p class="zlr-card-service-title">{{title}}</p>
      <div class="zlr-card-service-detail">
        <slot>
        </slot>
      </div>
      <span class="zlr-card-service-bg">{{ bgText || kind }}</span>
      <div class="zlr-card-service-dot"
           v-if="dotted">
        <div class="zlr-card-service-dot-con"
             v-for="(rowItem, rowIndex) in curDottedList"
             :key="rowIndex">
          <ul v-for="(colItem, colIndex) in rowItem"
              :key="colIndex">
            <li v-for="(numItem, numIndex) in colItem.conNum"
                :key="numIndex"
                :class="{'active': numItem<= colItem.activeNum}"></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="zlr-card-service-explain"
         v-show="!!explain">
      <div v-if="circle"
           class="zlr-card-service-circle"
           :class="[cardClass]"></div>
      <div>{{ explain }}</div>
    </div>
    <div class="zlr-card-service-explain-list"
         v-show="explainList && explainList.length > 0">
      <ul>
        <li v-for="(item, index) in explainList"
            :key="index"
            :style="{ 'border-color': item.color }">
          <div>{{item.title}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import './card-service.less'
const prefixCls = 'zlr-card-service'
const circleType = ['warning', 'waiting']
export default {
  name: 'zlr-card-service',
  props: {
    title: {
      type: [String]
    },
    bgText: {
      type: [String]
    },
    kind: {
      type: [String]
    },
    explain: {
      type: [String]
    },
    explainList: {
      type: [Array]
    },
    circle: {
      type: [String],
      validator: res => !res || circleType.includes(res)
    },
    dotted: {
      type: [Boolean],
      default: false
    },
    dottedList: {
      type: [Array],
      default () {
        return []
      }
    }
  },
  components: {},
  computed: {
    kindClass () {
      return `${prefixCls}-${this.kind}`
    },
    cardClass () {
      return `${prefixCls}-${this.circle}`
    }
  },
  data () {
    return {
      curDottedList: []
    }
  },
  mounted () {
    this.makeDottedList()
  },
  methods: {
    clickHandle () {
      this.$emit('click')
    },
    // 制造点
    makeDottedList () {
      let dottedLength = this.dottedList.length
      if (dottedLength === 0) {
        this.curDottedList = []
        return false
      }
      let curDottedList = []
      for (let i = 0; i < Math.ceil(dottedLength / 2); i++) {
        let arr = this.dottedList.slice(i * 2, i * 2 + 2)
        curDottedList.push(arr)
      }
      this.curDottedList = curDottedList
    }
  },
  watch: {
    dottedList () {
      this.makeDottedList()
    }
  }
}
</script>
<style lang='less' scoped>
</style>
